export default __webpack_public_path__ + "static/media/arrowLeft.62f53881.svg";